<template>
  <SpinnerComp v-if="loading" />
  <div v-else>
    <div v-if="isAdmin"
      v-show="!isHidden"
      class="fixed z-10 top-70 right-4 transition-opacity duration-300 bg-yellow-300 text-white rounded-full w-12 h-12 shadow-lg"
    >
      <button onclick="location.href='familias';" class="w-full h-full flex items-center justify-center">
        <i class="fas fa-edit text-lg"></i>
      </button>
    </div>

    <TableComp
      :data="{
        title: 'Productos',
        buttons: botones,
        headers: [
          'id',
          'Código',
          'SKU',
          'Nombre',
          'Descripción',
          'Unidad',
          'Stock',
          'Costo',
          'Utilidad',
          'Precio Venta',
          'Cotización P.',
          'Proveedor',
          'Opciones',
        ],
        visibleColumnsMobile: [1, 3, 4, 11, 12],
        ocultar: [0],
      }"
      :rows="rows"
      :options="options"
      @option-click="handleOptionAction"
    />

    <Modal
      v-if="isModalOpen"
      :isOpen="isModalOpen"
      :title="'Agregar Producto'"
      :fields="formFields"
      :submitButtonText="'Guardar Producto'"
      @close="closeModal"
      @submit="newProduct"
      @familia-change="updateCategories"
      @categoria-change="updateSubCategorias"
    />

    <Modal
      v-if="addFamilyOpen"
      :isOpen="addFamilyOpen"
      :title="'Añadir Familia'"
      :fields="formFieldsFamily"
      :submitButtonText="'Guardar Familia'"
      @close="closeModal"
      v-model="formData"
      @submit="NewFamily"
    />

    <Modal
      v-if="addCatCOpen"
      :isOpen="addCatCOpen"
      :title="'Añadir Categoria'"
      :fields="formFieldsCat"
      :submitButtonText="'Guardar Categoria'"
      @close="closeModal"
      @submit="NewCategory"
    />

    <Modal
      v-if="addSubCOpen"
      :isOpen="addSubCOpen"
      :title="'Añadir Subcategoria'"
      :fields="formFieldsSubC"
      :submitButtonText="'Guardar Subcategoria'"
      @close="closeModal"
      @familia-change="updateCategoriesAdd"
      @submit="NewSubCategory"
    />

    <ModalUpdateComp
      v-if="isModalUpdate"
      :title="'Actualizar Producto'"
      :isOpen="isModalUpdate"
      :selectedData="selectedRow"
      :formFields="formFields"
      @updateData="updateRowData"
      @familia-change="updateCategories"
      @categoria-change="updateSubCategorias"
      @close="closeModal"
    />

    <DeleteComp
      v-if="isDeleteOpen"
      :isOpen="isDeleteOpen"
      :deleteMessage="deleteMessage"
      @close="closeModal"
      @confirm="deleteProduct"
    />
  </div>
</template>

<script>
import TableComp from "@/components/TableComp.vue";
import Modal from "@/components/ModalComp.vue";
import ModalUpdateComp from "@/components/ModalUpdateComp.vue";
import SpinnerComp from "@/components/SpinnerComp.vue";
import DeleteComp from "@/components/DeleteComp.vue";
export default {
  components: {
    TableComp,
    Modal,
    ModalUpdateComp,
    SpinnerComp,
    DeleteComp,
  },
  data() {
    return {
      proveedores: null,
      familias: null,
      categorias: null,
      subcategorias: null,
      isDeleteOpen: false,
      isModalOpen: false,
      isModalUpdate: false,
      addFamilyOpen: false,
      addSubCOpen: false,
      addCatCOpen: false,
      loading: false,
      rows: [],
      isSubmittingForm: false,
      isHidden:false,
      isAdmin: false,
      botones: null,
      formFields: [
        {
          label: "Nombre",
          model: "nombre",
          placeholder: "Ingrese el nombre",
        },
        {
          label: "Familia",
          model: "familia",
          type: "select",
          options: [],
        },
        {
          label: "Categoría",
          model: "categoría",
          type: "select",
          options: [], // Inicializamos vacío
        },
        {
          label: "SubCategoría",
          model: "subcategoría",
          type: "select",
          options: ["Seleccionar SubCategoría"], // Inicializamos con opción predeterminada
        },
        {
          label: "Código",
          model: "Codigo",
          type: "text",
          placeholder: "Código",
        },
        { label: "SKU", model: "sku", type: "text", placeholder: "SKU" },
        {
          label: "Unidad",
          model: "unidad",
          type: "select",
          options: [
            { label: "Pieza", value: "pza" },
            { label: "Caja", value: "cja" },
            { label: "Metro", value: "m" },
            { label: "Litro", value: "l" },
            { label: "Servicio", value: "svo" },
            { label: "Kit", value: "kit" },
            { label: "Hora", value: "h" },
            { label: "ft3", value: "ft3" },
          ],
        },
        {
          label: "Inventario - Existencia",
          model: "inventario",
          type: "input",
          placeholder: "Existencia",
        },
        {
          label: "Descripcion",
          model: "descripcion",
          type: "textarea",
          placeholder: "Descripcion",
        },
        {
          label: "Notas del Producto",
          model: "notas",
          type: "textarea",
          placeholder: "Notas",
        },
        {
          label: "Costo",
          model: "costo",
          type: "input",
          placeholder: "Costo",
        },
        {
          label: "Importación",
          model: "importacion",
          type: "checkbox",
        },
        {
          label: "Utilidad %",
          model: "utilidad",
          type: "input",
          placeholder: "Utilidad",
        },
        {
          label: "Precio Venta",
          model: "precioventa",
          type: "input",
          placeholder: "Precio Venta",
        },
        {
          label: "Utilidad Esperada",
          model: "utilidadE",
          type: "input",
          placeholder: "Utilidad en $",
        },
        {
          label: "Cotización del Proveedor",
          model: "cotizacion",
          type: "input",
          placeholder: "Cotización del Proveedor",
        },
        {
          label: "Nombre Proveedor",
          model: "proveedores",
          type: "select",
          options: ["Seleccionar Proveedor"],
        },
        {
          label: "Última modificación",
          model:"modificacion",
          type: "label",
        }
      ],
      formFieldsFamily: [
        {
          label: "Familia",
          model: "nombre",
          placeholder: " Ingrese la nueva familia",
        },
        {
          label: "Identificador",
          model: "identificador",
          placeholder: " Ingrese el identificador",
        },
      ],
      formFieldsCat: [
        {
          label: "Familia",
          model: "familia",
          type: "select",
          placeholder: " Ingrese la familia",
          options: [{ label: "prueba", value: 1 }],
        },
        {
          label: "Categoria",
          model: "nombre",
          placeholder: " Ingrese la categoria",
        },
        {
          label: "Identificador",
          model: "identificador",
          placeholder: " Ingrese el identificador",
        },
      ],
      formFieldsSubC: [
        {
          label: "Familia",
          model: "familia",
          type: "select",
          placeholder: " Ingrese la familia",
          options: [{ label: "", value: 1 }],
        },
        {
          label: "Categoria",
          model: "categoria",
          type: "select",
          placeholder: " Ingrese la categoria",
          options: [{ }],
        },
        {
          label: "Subcategoria",
          model: "nombre",
          placeholder: " Ingrese la Subcategoria",
        },
        {
          label: "Identificador",
          model: "identificador",
          placeholder: " Ingrese el identificador",
        },
      ],
      options: [
        {
          icon: "material-symbols-outlined edit",
          action: "edit",
          color: "bg-yellow-300",
        },
        {
          icon: "material-symbols-outlined delete",
          action: "delete",
          color: "bg-red-500",
        },
      ],
      selectedRow: null,
    };
  },

  methods: {
    handleScroll() {
      // Detecta si el scroll está dentro del rango de la barra superior
      const scrollTop = window.scrollY;
      this.isHidden = scrollTop > 100; // Oculta el botón al pasar 100px
    },
    openModal() {
      this.isModalOpen = true;
    },
    openModalFamily() {
      this.addFamilyOpen = true;
    },
    openModalSubC() {
      this.$axios.get("/getFam").then((response) => {
        this.familias = response.data.familias || []; // Ajusta según la estructura de tu respuesta
        this.formFieldsSubC.forEach((field) => {
          if (field.model === "familia") {
            field.options = this.familias.map((fam) => ({
              label: fam.nombre,
              value: fam.identificador,
            }));
          }
        });
        this.addSubCOpen = true;
      });
    },
    openModalCat() {
      this.$axios.get("/getFam").then((response) => {
        this.familias = response.data.familias || []; // Ajusta según la estructura de tu respuesta
        this.formFieldsCat.forEach((field) => {
          if (field.model === "familia") {
            field.options = this.familias.map((fam) => ({
              label: fam.nombre,
              value: fam.identificador,
            }));
          }
        });
        this.addCatCOpen = true;
      });
    },
    closeModal() {
      this.isModalOpen = false;
      this.isModalUpdate = false;
      this.addFamilyOpen = false;
      this.addSubCOpen = false;
      this.isDeleteOpen = false;
      this.addCatCOpen = false;
    },
    handleOptionAction(action, row) {
      const actions = {
        edit: () => {
          this.$axios.get(`/getProOne/${row.id}`).then((response) => {
            this.selectedRow = response.data.producto;
            this.selectedRow.categoría = undefined;
            this.selectedRow.familia = undefined;
            this.selectedRow.subcategoría = undefined;
            this.isModalUpdate = true;
          });
        },
        delete: () => {
          this.deleteMessage = `¿Estás seguro de que deseas eliminar: ${row.nombre}?`;
          this.id = row.id;
          this.isDeleteOpen = true;
        },
      };
      if (actions[action]) {
        actions[action]();
      }
    },
    getData() {
      this.loading = true;
      this.$axios
        .get("/getPro")
        .then((response) => {
          this.rows = response.data.producto.map((item) => ({
            id: item.id,
            codigo: item.codigo,
            sku: item.sku,
            nombre: item.nombre,
            descripcion: item.descripcion,
            unidad: item.unidad,
            Stock: item.Stock,
            precio: item.precio,
            utilidad: item.utilidad,
            precioUtil: item.precioUtil,
            cotProP: item.cotProP,
            proveedor: item.nombreProveedor,
          }));
        })
        .catch((error) => {
          alert(error.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteProduct() {
      this.$axios
        .delete(`/deletePro/${this.id}`)
        .then((response) => {
          this.closeModal();
          alert(response.data.message);
          this.getData();
        })
        .catch((error) => {
          if (error.response) {
            alert(error.response.data.message);
          }
        });
    },
    getFam() {
      this.$axios
        .get("/getFam")
        .then((response) => {
          this.familias = response.data.familias || [];
          this.formFields.forEach((field) => {
            if (field.model === "familia") {
              field.options = this.familias.map((fam) => ({
                label: fam.nombre,
                value: fam.identificador,
              }));
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    getProveedores() {
      this.$axios
        .get("/getPrv") // Llamada al endpoint que has definido en el controlador
        .then((response) => {
          // Asegúrate de que la respuesta contiene los proveedores
          if (response.data.estado === "ok") {
            const proveedores = response.data.proveedores || [];
            const proveedorField = this.formFields.find(
              (field) => field.model === "proveedores"
            ); // Encuentra el campo del proveedor

            // Extraer solo nombreP e idP
            proveedorField.options = proveedores.map((prov) => ({
              label: prov.nombreP, // Nombre del proveedor
              value: prov.idP, // ID del proveedor
            }));
          }
        })
        .catch(() => {
          alert("No se pudieron cargar los proveedores");
        });
    },
    updateCategories(familiaId) {
      // Solicitar categorías basadas en la familia seleccionada
      this.$axios
        .get(`/getCategorias/${familiaId}`)
        .then((response) => {
          if (response.data.estado === "ok") {
            const categorias = response.data.categorias || [];
            const categoriaField = this.formFields.find(
              (field) => field.model === "categoría"
            );
            const subcategoriaField = this.formFields.find(
              (field) => field.model === "subcategoría"
            );

            subcategoriaField.options = [];
            // Actualizar opciones de categorías
            categoriaField.options = categorias.map((cat) => ({
              label: cat.nombre,
              value: cat.identificador,
            }));
          }
        })
        .catch(() => {
          alert("No se pudieron cargar las categorías");
        });
    },
    updateCategoriesAdd(familiaId) {
      this.$axios
        .get(`/getCategorias/${familiaId}`)
        .then((response) => {
          if (response.data.estado === "ok") {
            const categorias = response.data.categorias || [];
            const categoriaField = this.formFieldsSubC.find(
              (field) => field.model === "categoria"
            );
            // Actualizar opciones de categorías
            categoriaField.options = categorias.map((cat) => ({
              label: cat.nombre,
              value: cat.id,
            }));
          }
        })
        .catch(() => {
          alert("No se pudieron cargar las categorías");
        });
    },
    updateSubCategorias(familiaId, categoriaId) {
      // Solicitar categorías basadas en la familia seleccionada
      this.$axios
        .get(`/getSubcategorias/${familiaId}/${categoriaId}`)
        .then((response) => {
          if (response.data.estado === "ok") {
            const subcategorias = response.data.subcategorias || [];
            const subcategoriaField = this.formFields.find(
              (field) => field.model === "subcategoría"
            );

            // Actualizar opciones de categorías
            subcategoriaField.options = subcategorias.map((cat) => ({
              label: cat.nombre,
              value: cat.identificador,
            }));
          }
        });
    },
    updateRowData(formData) {
      this.$axios
        .put(`/updatePro/${formData.id}`, {
          nombre: formData.nombre,
          codigo: formData.Codigo,
          sku: formData.sku,
          unidad: formData.unidad,
          existencia: formData.inventario,
          descripcion: formData.descripcion,
          notas: formData.notas,
          costoUSD: formData.costo,
          utilidad: formData.utilidad,
          precio: formData.costo,
          precioUtil: formData.precioventa,
          cotProP: formData.cotizacion,
          idProP: formData.proveedores,
          importacion: formData.importacion,
        })
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
          this.getData();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    },
    NewFamily(formData) {
      if (this.isSubmittingForm) return;
      this.isSubmittingForm = true;
      this.$axios
        .post("/registerFam", formData)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
        })
        .catch((error) => {
          alert(error.response.data.message);
        })
        .finally(() => {
          this.isSubmittingForm = false;
        });
    },
    NewCategory(formData) {
      if (this.isSubmittingForm) return;
      this.isSubmittingForm = true;
      this.$axios
        .post("/registerCat", formData)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
        })
        .catch((error) => {
          alert(error.response.data.message);
        })
        .finally(() => {
          this.isSubmittingForm = false;
        });
    },
    NewSubCategory(formData) {
      if (this.isSubmittingForm) return;
      this.isSubmittingForm = true;
      this.$axios
        .post("/register_Sub", formData)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
        })
        .catch((error) => {
          alert(error.response.data.message);
        })
        .finally(() => {
          this.isSubmittingForm = false;
        });
    },
    getPermisos(){
      this.$axios.get('/user').then(response =>{
        if(response.data.usuario === 'admin'){
          this.botones = [
            { text: 'Nuevo Producto', action: this.openModal },
            { text: 'Añadir Familia', action: this.openModalFamily },
            { text: 'Añadir Categoria', action: this.openModalCat },
            { text: 'Añadir SubCategoría ', action: this.openModalSubC },
          ]
          this.isAdmin = true;
        }else{
          this.botones = [
            { text: 'Nuevo Producto', action: this.openModal },
          ]
        }
      });
    },
    newProduct(formData) {
      if (this.isSubmittingForm) return;
      this.isSubmittingForm = true;
      this.$axios
        .post("/registerPro", {
          nombre: formData.nombre,
          codigo: formData.Codigo,
          sku: formData.sku,
          unidad: formData.unidad,
          existencia: formData.inventario,
          descripcion: formData.descripcion,
          notas: formData.notas,
          costoUSD: formData.costo,
          utilidad: formData.utilidad,
          precio: formData.costo,
          precioUtil: formData.precioventa,
          cotProP: formData.cotizacion,
          idProP: formData.proveedores,
          importacion: formData.importacion,
        })
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
          this.getData();
        })
        .catch((error) => {
          alert(error.response.data.message);
        })
        .finally(() => {
          this.isSubmittingForm = false;
        });
    },
  },
  mounted() {
    this.getProveedores();
    this.getData();
    this.getFam();
    this.getPermisos();
    if (this.familias && this.familias.length > 0) {
      this.formData.familia = this.familias[0].id;
      this.handleFamiliaChange(this.familias[0].id);
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    // Remueve el evento de scroll al destruir el componente
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    "formData.familia": function (newFamiliaId) {
      if (newFamiliaId) {
        this.handleFamiliaChange(newFamiliaId);
      }
    },
  },
};
</script>
